type AttributeLike = {
  shortId: string;
  isActive: boolean;
};

// Attributes still available to add to a journey form: active and not already
// placed in the form. An empty result drives the "All added" badge.
export const getAvailableAttributes = <T extends AttributeLike>(
  attributes: T[],
  usedIds: Array<string | undefined>
): T[] =>
  attributes.filter((attribute) => attribute.isActive && !usedIds.includes(attribute.shortId));
